import { Box, Stack } from "@mui/material";
import { Custom, FormProfile, Workflow } from "components";
import { useProfileForm } from "components/form/profile/useProfileForm";
import { useData, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef } from "react";
import { createStep } from "utils/helpers";

const StepUpdate = forwardRef(() => {
  const { prevStep } = useWorkflow<Workflow.Utils.ProfileType>();
  const { user } = useData();
  const { theme } = useTheme();
  const {
    state,
    t,
    onChange,
    onCustomChange,
    handleValidation,
    handlePreferenceChange,
    handleSubmit,
  } = useProfileForm(user, prevStep);

  return (
    <Box component="form" onSubmit={handleSubmit}>
      {state && (
        <Stack spacing={theme.spacing.sm}>
          <Box>
            <FormProfile.Fields
              state={state}
              t={t}
              onChange={onChange}
              onValidation={handleValidation}
              onCustomChange={onCustomChange}
              handlePreferenceChange={handlePreferenceChange}
            />
          </Box>
          <Custom.Button fullWidth variant="contained" trailing="right" submit>
            {t.action.save}
          </Custom.Button>
        </Stack>
      )}
    </Box>
  );
});

export default createStep<Workflow.Utils.ProfileType>(StepUpdate);
